import { render } from "./Carousel.vue?vue&type=template&id=1a1b582c&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=1a1b582c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1b582c"],['__file',"src/js/components/Carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a1b582c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a1b582c', __exports__)) {
    api.reload('1a1b582c', __exports__)
  }
  
  module.hot.accept("./Carousel.vue?vue&type=template&id=1a1b582c&scoped=true", () => {
    api.rerender('1a1b582c', render)
  })

}


export default __exports__